<template>
    <div id="results" class="page">
          <div class="head-wrapper">
            <h2 class="head-copy in">Verification</h2>
            <p class="sub-copy in">Please answer the following question: </p>
          </div>

          <div class="stage-wrapper">
            <div class="math-problem">
              <h2>
                <span class="numerator">{{firstInt}}</span>
                <span class="action">{{expresionSymbol}}</span>
                <span class="denominator">{{secondInt}}</span>
              </h2>
            </div>

            <div id="user-form">

              <Input
                v-model="userSolution"
                defaultText="Solution"
                dataType="number"
                :customFilter="(val) => { return checkSolution(val) }"
              />

            </div>

              <Button
                :isValid="userSolution != null && userSolution != '' && userSolution == solution"
                label="Submit"
                :callback="submitData"
                :hasSpinner='true'
              />

          </div>



    </div>
</template>

<script>
import Button from '../components/shared/Button'
import Input from '../components/shared/Input'
import {getRandNum, getRandAction, evalString} from '../utils'

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Verification',
  components: {
    Button,
    Input,
  },

  data(){
    return {
      firstInt: null,
      secondInt: null,
      expresionSymbol: '',
      validInput: true,
      userSolution: null,
      solution: null,
      submitting: false,
    }
  },

  computed: {
    ...mapGetters([
      'prizeID',
      'userSubmitData',
    ])

  },

  mounted(){
    this.generateMathProblem();
  },

  updated(){
    //this.validateData();

  },

  methods: {
    ...mapActions(['createUser']),

    checkSolution(val){
      return val == this.solution ? false : true

    },

    generateMathProblem(){
      let intA = getRandNum();
      let intB = getRandNum();

      let expression = getRandAction();
      this.expresionSymbol = expression;

      // prevent negative number as solution
      if(expression === '-'){
        if (intA > intB){
          this.firstInt = intA;
          this.secondInt = intB;

        } else {
          this.firstInt = intB;
          this.secondInt = intA;

        }

      } else {
        this.firstInt = intA;
        this.secondInt = intB;

      }

      let answer = evalString(expression, this.firstInt, this.secondInt);
      this.solution = answer;

    },

    submitData(){
      if( this.submitting ) {
        return;
      }

      this.submitting = true;

      this.createUser(this.userSubmitData)

        .then((data) => {
          if(data.error){
            // error
            this.$router.push('tryagain')

          } else {
            this.$router.push('confirmation')

          }

        })
        .catch(() => {
            // REMOVE
            this.$router.push('tryagain')

        });

    }

  }

}
</script>


<style lang="scss">
@import "../styles/_variables.scss";
@import "../styles/_mixins.scss";

.math-problem {
  padding-top: 12.5vh;

  span {
    font-size: 3.85em;

    &.action {
      font-size: 2.85em;
      margin: 0 0.15em;

      //transform: translateY(-.25em);
    }

  }
}

#results {

.head-wrapper {
  height: 25vh;
}

}

#floating-egg {
    position: absolute;
    width: 4rem;
    height: 6rem;
    top: 1.65em;
    overflow: hidden;
    right: .5rem;
}

#user-form{
  margin-bottom: 1.5rem;

    @media screen and (min-width: 600px) and (max-width: 768px) {
      margin-top: 1.25em;
    }

    @media only screen and (max-width: 600px) {
      margin-top: 1.25em;
    }

}

.grid {
  display: flex;
  margin: 0 .125em;

  & div {
    margin-right: .5em;

    &:last-of-type {
      margin-right: 0em;
    }
  }

}

</style>
